import type { AirportOption } from "@seagames/contracts";
import { queryOptions } from "@tanstack/react-query";
import { api } from "./client";

/**
 * Airports (0087): the world list, read-only, for the airport picker
 * (`AirportSelect`). Any signed-in role reads it. The server orders the
 * answer (exact code, code prefix, size, name / city) — never re-sorted here.
 */
export const airportKeys = {
	all: ["airports"] as const,
	options: (q: string) => ["airports", "options", q] as const,
};

/** `GET /airports/options?q=` — `q` already trimmed and ≥ AIRPORT_OPTIONS_Q_MIN (see `airportSearchTerm`). Airports barely change: cached long. */
export const airportOptionsOptions = (q: string) =>
	queryOptions({
		queryKey: airportKeys.options(q),
		queryFn: ({ signal }) => api.get<{ items: AirportOption[] }>("/airports/options", { query: { q }, signal }),
		staleTime: 30 * 60_000,
		gcTime: 30 * 60_000,
	});
